/**
 * CoachPlaybook - Sport Modules Registry
 * Version: 0.6.0
 * Description: Central registry for installable sport modules
 */

import basketball from './basketball';
import soccer from './soccer';
import baseball from './baseball';
import football from './football';
import volleyball from './volleyball';

// All available sport modules
const SPORT_MODULES = {
  basketball,
  soccer,
  baseball,
  football,
  volleyball
};

// Get a sport config by ID
export const getSport = (sportId) => SPORT_MODULES[sportId] || null;

// Get all available sports (for sport picker UI)
export const getAllSports = () => Object.values(SPORT_MODULES);

// Get sport IDs
export const getSportIds = () => Object.keys(SPORT_MODULES);

// Get default sport
export const getDefaultSport = () => SPORT_MODULES.basketball;

export default SPORT_MODULES;
